export default [
  { path: '/configuracion/datos-generales', meta: { needMe: true }, component: () => import('@/views/config/Settings.vue') },
  { path: '/configuracion/not-factura', component: () => import('@/views/config/Notifications.vue') },
  { path: '/configuracion/gestion-de-claves', meta: { needMe: true, userRoleAllowed: ['ROLE_ADMIN'] }, component: () => import('@/views/config/KeysManagement.vue') },
  { path: '/configuracion/catalogo', component: () => import('@/views/config/Catalog.vue') },
  { path: '/configuracion/formato-factura', component: () => import('@/views/config/Format.vue') },
  { path: '/configuracion/users', component: () => import('@/views/config/Users.vue') }
]
